<template>
  <div
    v-if="showSku || showPoints"
    :class="[
      $style.container,
      {
        [$style['product-detail']]: isProductDetail,
        [$style['new-line']]: useNewLine
      }
    ]"
  >
    <div v-if="showSku" :class="$style.sku" itemprop="sku">
      <span :class="$style['sku-translation']">{{ translations.item }} #</span>
      <span :class="$style['sku-value']">{{ sku }}</span>
    </div>
    <div
      v-if="showPoints"
      :class="[$style.points, { [$style['hide-before']]: !showSku }]"
    >
      <span :class="$style['points-translation']">{{ translations.psv }}:</span>
      <span :class="$style['points-value']" data-testid="sv">{{
        fixedPoints
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "NsProductSkuPoints",
  props: {
    /**
     * Will show points even if not distributor
     */
    forcesv: Boolean,
    /**
     * Will hide sku
     */
    hideSku: Boolean,
    /**
     * True if use is distributor
     */
    isDistributor: Boolean,
    /**
     * The amount of points
     */
    points: {
      type: String,
      default: null
    },
    /**
     * True if parent is ProductDetail
     */
    isProductDetail: Boolean,
    /**
     * Determines if the sku and points should be on separate lines
     */
    useNewLine: Boolean,
    /**
     * The sku
     */
    sku: {
      type: String,
      default: ""
    },
    /**
     * The translations
     */
    translations: {
      type: Object,
      default() {
        return {
          item: "Item",
          psv: "Points"
        };
      }
    }
  },
  computed: {
    fixedPoints() {
      return parseFloat(this.points).toFixed(2);
    },
    showSku() {
      return !this.hideSku;
    },
    showPoints() {
      return this.points && (this.isDistributor || this.forcesv);
    }
  }
};
</script>

<style lang="scss" module>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typography";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

.container {
  &.product-detail {
    .sku {
      font-weight: map.get(typographyVariables.$typography, font-weight-medium);
    }
  }

  .sku {
    color: map.get(colors.$themeColors, color-interactive-8);
  }

  .points {
    position: relative;
    color: map.get(colors.$themeColors, color-interactive-8);

    .points-value {
      color: map.get(colors.$themeColors, color-interactive-8);
      font-weight: map.get(
        typographyVariables.$typography,
        font-weight-semibold
      );
    }
  }

  .sku-translation::after,
  .points-translation::after {
    content: " ";
  }
}

.container:not(.new-line) {
  display: grid;
  grid-gap: 20px;
  grid-auto-flow: column;
  justify-content: center;

  .points::before {
    content: "";
    position: absolute;
    left: -10px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 1px;
    height: 10px;
    background-color: map.get(colors.$themeColors, color-gray-1);
  }

  .points {
    &.hide-before::before {
      display: none;
    }
  }
}

.container.new-line {
  .points {
    padding-top: 6px;
  }
}
</style>
